import React, { Component } from "react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-autoplay.css";
import "lightgallery/css/lg-share.css";
import "lightgallery/css/lg-rotate.css";
import LightGallery from 'lightgallery/react/Lightgallery.es5';
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgAutoplay from "lightgallery/plugins/autoplay";
import lgVideo from "lightgallery/plugins/video";
import lgShare from "lightgallery/plugins/share";
import lgRotate from "lightgallery/plugins/rotate";
import g1 from '../../assets/images/gallery/pic1.jpg';
import g2 from '../../assets/images/gallery/pic2.jpg';
import g3 from '../../assets/images/gallery/pic3.jpg';
import g4 from '../../assets/images/gallery/pic4.jpg';
import g5 from '../../assets/images/gallery/pic5.jpg';
import g6 from '../../assets/images/gallery/pic6.jpg';
import g7 from '../../assets/images/gallery/pic7.jpg';
import g8 from '../../assets/images/gallery/pic8.jpg';
function Photogallery() {
    return (
        <>
           <LightGallery
speed={500}
plugins={[lgThumbnail,lgShare,lgAutoplay,lgRotate,lgVideo,lgZoom]}
>
<a href={g1}>
  <img src={g1} alt="Photo Gallery"/>
</a>
<a href={g2}>
  <img src={g2} alt="Photo Gallery"/>
</a>
<a href={g3}>
  <img src={g3} alt="Photo Gallery"/>
</a>
<a href={g4}>
  <img src={g4} alt="Photo Gallery"/>
</a>
<a href={g5}>
  <img src={g5} alt="Photo Gallery"/>
</a>
<a href={g6}>
  <img src={g6} alt="Photo Gallery"/>
</a>
<a href={g7}>
  <img src={g7} alt="Photo Gallery"/>
</a>
<a href={g8}>
  <img src={g8} alt="Photo Gallery"/>
</a>
</LightGallery>
        </>
        );
    }
    export default Photogallery